import { motion } from "framer-motion";
import { useContent } from "../../i18n/useContent";
import { RevealGroup, revealItemVariants } from "../ui/Reveal";
import "./Clients.css";

function ClientLogo({ item }) {
  const img = <img className="clients-badge-logo" src={item.src} alt="" loading="lazy" />;
  if (item.dark) {
    return <span className="clients-badge-logo-chip">{img}</span>;
  }
  return img;
}

export default function Clients() {
  const { clients } = useContent();

  return (
    <section id="clientes" className="section">
      <div className="container">
        <div className="section-head center">
          <p className="eyebrow">{clients.eyebrow}</p>
          <h2 className="section-title">{clients.title}</h2>
          <p className="section-lead">{clients.lead}</p>
        </div>

        <RevealGroup className="clients-grid" as="ul">
          {clients.list.map((client) => (
            <motion.li className="clients-badge" variants={revealItemVariants} key={client.name}>
              {client.logo ? (
                Array.isArray(client.logo) ? (
                  <span className="clients-badge-logo-group" role="img" aria-label={client.name}>
                    {client.logo.map((item) => (
                      <ClientLogo item={item} key={item.src} />
                    ))}
                  </span>
                ) : (
                  <img
                    className={
                      client.big ? "clients-badge-logo clients-badge-logo--lg" : "clients-badge-logo"
                    }
                    src={client.logo}
                    alt={client.name}
                    loading="lazy"
                  />
                )
              ) : (
                <span className="clients-badge-name">{client.name}</span>
              )}
            </motion.li>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
}
